import React, { useState, useEffect } from "react";
import "./index.scss";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import { queryAdvanceRule } from "@/api";
import request from "@/utils/request";
import { Modal, Icon, Toast } from "antd-mobile";
import testData from "./test.json"; 

// import Header from '@/components/header'
// import rightBtn from '@/assets/images/rightbtn.png'
const Help = (props) => {
  const [text, setText] = useState("");
  const columns = [
    { header: "时间段", accessor: "timePeriod" },
    { header: "起步价", accessor: "startingPrice" },
    { header: "里程单价", accessor: "mileagePrice" },
    { header: "时长单价", accessor: "durationPrice" },
    { header: "远途起始里程20单价", accessor: "longDistance20Price" },
    { header: "远途起始里程30单价", accessor: "longDistance30Price" },
  ];

  const formatData = (data) => {
    return data.map((item) => {
      let timePeriod = item.memo 
        ? `${new Date(item.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}-${new Date(item.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` 
        : "全天";
      return {
        timePeriod,
        startingPrice: item.startPrice,
        mileagePrice: item.distancePrice,
        durationPrice: item.timePrice,
        longDistance20Price: item.longDistancePrice1,
        longDistance30Price: item.longDistancePrice2,
      };
    });
  };

  const data1 = formatData(testData.ruleDetailDTOList.filter(item => item.userType === 2 && item.dayType === 1));
  const data2 = formatData(testData.ruleDetailDTOList.filter(item => item.userType === 2 && item.dayType === 2));

  let token = getLocationSearch().token;
  let tenantTag = getLocationSearch().tenantTag;
  const initRequest = async () => {
    let appKey = "app_h5";
    let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.get(
      queryAdvanceRule,
      { token },
      {
        appKey: appKey,
        timestamp: timestamp,
        random: random,
        token: token,
        sign: sign,
      }
    );
    Toast.hide();
    if (res.data.data) {
      setText(res.data.data);
    }
  };
  useEffect(() => {
    initRequest();
  }, []);
  return (
    <div className="help__box">
      <div className="help-con">
        {/* <div className="help-con__btn">
          <article>
            {
              spanBtn.map((item, index) => {
                return <span key={index} className={activeC === index ? 'active' : ''} onClick={handleTab.bind(this, index)}>问题类型</span>
              })
            }
          </article>
        </div> */}
        <div className="help__list">
          <div className="help__list__show">
            {text ? (
              <div className="help-con__list">
                <h2>垫付规则</h2>
                <p
                  dangerouslySetInnerHTML={{ __html: text }}
                  className="d_rule"
                ></p>
              </div>
            ) : null}
            <div className="help-con__list">
              <h2>听单派单</h2>
              <h3>听不到单/听单较少的原因</h3>
              <h4>听单窍门：</h4>
              <p>
                1 .听单中请避免频繁将司机端切换至后台运行（如接打电
                话、浏览其它软件等），以免导致网络延迟影响听单。
              </p>
              <p>
                2 .前往热点商圈听单：早晚高峰期间订单需求较多，可前
                往办公楼或热点商圈接单。
              </p>
              <h3>接单距离较远</h3>
              <p>
                尊敬的车主，派单是系统根据乘客发单位置进行派
                单，也是优先派给距离乘客最近的司机师傅的；如订单派单较远，可能是当前所属位置的司机较少，也希望您正常
                服务乘客，感谢您及时的反馈，平台会根据您的反馈进行改善
              </p>
            </div>
            <div className="help-con__list">
              <h2>订单相关</h2>
              <h3>乘客出行计划有变</h3>
              <p>
                若乘客表示无法出行，建议您与乘客协商取消订单。如您仍有疑问，请联系客服为您处理.
              </p>
              <h3>接单后无法服务</h3>
              <p>
                尊敬的车主，接单后因个人或其他原因无法服务乘客
                请及时向乘客致歉说明，可协商取消订单请乘客另外叫车。
              </p>
              <h3>接单后联系不上乘客 </h3>
              <p>
                到达上车位置后联系不上乘客，如果当日取消1次以内，可以直接取消，并且等候超时，会有一定超时赔偿哦；如果当日取消超过了1次，请联系客服取消，同样，如果等候超时，也会有一定超时赔偿哦~
              </p>
              <h3>如何修改订单价格</h3>
              <p>
                若订单金额异常需要修改，请点击【转人工】反馈客服处理，感谢您的理解。
              </p>
            </div>
            <div className="help-con__list">
              <h2>提现相关</h2>
              <h3>如何提现</h3>
              <p>
                点击司机端左上角【我】•【钱包】•【提现】即可提现，提现只能提现到本人支付宝账户哦~下方【提现规则】可了解具体规则，提现不收取手续费。
              </p>
              <h3>提现到账时间</h3>
              <p>
                提现成功后2小时到账，如逾期没有到账，请您查询支付宝-出入账明细和司机端账户是否有退回哦~
              </p>
            </div>
            <div className="help-con__list">
              <h2>奖励相关</h2>
              <h3>未收到奖励</h3>
              <h4>未收到奖励分为以下情况：</h4>
              <p>
                1 .完成订单不符合奖励规则：
                您也在奖励界面查询规则内要求的订单数、成交率、订单
                时间和地点等，只有完成符合奖励条件的订单才可以哦。{" "}
              </p>
              <p>
                2 .奖励发放时间：
                奖励分实时到账和结束后统一发放两种哦，您可根据奖励
                规则内的发放时间判断您的奖励发放情况。
              </p>
              <p>
                3 .奖励延迟发放：
                当奖励获得人数超限或其它原因导致奖励延迟发放的，平台会及时做出通知，还请符合奖励的师傅们，不要着急耐
                心等待一下下~{" "}
              </p>
              <h3>收到奖励金额不正确</h3>
              <p>
                收到奖励金额不正确，请先核是否完成奖励要求，您可根
                据您的接单情况，自行计算您的奖励金额。如您的奖励符合要求暂时未发放，我们会在7天内给您补发，请您关注您的账户流水。
              </p>
            </div>
            <div className="help-con__list">
              <h2>司机服务</h2>
              <h3>司机提供哪些服务</h3>
              <p>
                尊敬的车主，好的服务更能获得乘客的认可和好评哦。
                如准时到达、保持车内整洁等，根据乘客需求选择是否开空调，将会给乘客带来舒适的行程。
              </p>
            </div>
            <div className="help-con__list">
              <h2>附加费用</h2>
              <h3>高速费/过桥费如何处理 </h3>
              <p>
                尊敬的车主，高速费和过桥费是在服务乘客时，经过高速和高架桥时产生的费用，当订单产生高速费和过桥费时需要您和乘客确认后，由乘客线下自行支付给司机的哦~
              </p>
              <br />
              <p>
                温馨提示：如乘客往返行程，需要与乘客沟通后，才能收取双程费用哦~
              </p>
            </div>

            {tenantTag=='ydrd'?<div className="help-con__list">
              <h2>工作日计价规则</h2>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th key={column.accessor}>{column.header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data1.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {columns.map((column) => (
                          <td key={column.accessor}>{row[column.accessor]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>:null}

            {tenantTag=='ydrd'?<div className="help-con__list">
              <h2>休息日计价规则</h2>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th key={column.accessor}>{column.header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {columns.map((column) => (
                          <td key={column.accessor}>{row[column.accessor]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>:null}

          </div>
        </div>
      </div>
    </div>
  );
};
export default Help;
